<template>
  <SettingItemBox :title="$t('quickResponse') | capitalize">
    <template v-slot:content>
      <div class="filter-box" style="margin-bottom: 6px !important; justify-content: space-between; align-items: center;">
        <v-btn flat small class="btn-create hidden-sm-and-down" @click="openDialogCreateQuickResponseLeader">
          <v-icon right left size="14" color="#ffff">mdi-plus-circle</v-icon>
          <span class="btn-text">{{ $t('createNew') | capitalize }}</span></v-btn>
        <v-btn flat icon class="show-on-sm-and-down hidden-md-and-up" color="#0052CC" style="margin: 0" @click="openDialogCreateQuickResponseLeader">
          <v-icon right left size="14">mdi-plus-circle</v-icon>
        </v-btn>
        <div style="float: right;">
          <v-btn flat small class="btn-export hidden-sm-and-down" @click="exportAgentQuickResponseLeader({'sortBy':sortBy,'search':search, 'filteredSkill': filteredSkill})" :disabled="isLockReport">
          <v-icon right left size="14" color="#0052cc">mdi-export</v-icon>
          <span class="btn-text">{{ $t('export') | capitalize }}</span></v-btn>
          <v-btn flat icon class="show-on-sm-and-down hidden-md-and-up" color="#0052CC" style="margin: 0" @click="exportAgentQuickResponseLeader({'sortBy':sortBy,'search':search, 'filteredSkill': filteredSkill})" :disabled="isLockReport">
            <v-icon right left size="14">mdi-export</v-icon>
          </v-btn>
          <v-btn flat small class="btn-import hidden-sm-and-down" @click="openDialogImportAgentQuickResponseLeader">
          <v-icon right left size="14" color="#0052CC">mdi-import</v-icon>
          <span class="btn-text">{{ $t('import') | capitalize }}</span></v-btn>
          <v-btn flat icon class="show-on-sm-and-down hidden-md-and-up" color="#0052CC" style="margin: 0" @click="openDialogImportAgentQuickResponseLeader">
            <v-icon right left size="14">mdi-import</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="filter-box">
        <div class="search-quick-response">
          <v-icon size="20" class="search-quick-response-icon">mdi-magnify</v-icon>
          <input v-model='search' type="text" autocomplete="nope" :placeholder="$t('search') | capitalize"/>
        </div>
        <div class="sort-quick-response">
          <span class="sort-label">{{ $t('quickResponseForm.group') | capitalize }}:</span>
          <v-select
              v-model="filteredSkill"
              height="37"
              hide-details
              append-icon="mdi-chevron-down"
              solo
              flat
              :items="skillGroupOptions"
              item-text="name"
              item-value="id"
          >
            <template #selection="{item}">
              <span class="selection-txt">{{ item.name | capitalize}}</span>
            </template>
          </v-select>
        </div>
        <div class="sort-quick-response">
          <span class="sort-label">{{ $t('sort') | capitalize }}:</span>
          <v-select
              v-model="sortBy"
              height="37"
              hide-details
              append-icon="mdi-chevron-down"
              solo
              flat
              :items="selectItems"
              item-text="label"
          >
            <template #selection="{item}">
              <span class="selection-txt">{{ item.label }}</span>
            </template>
          </v-select>
        </div>
       
      </div>
      <div class="list-quick-response scroll-thin">
        <AgentQuickResponseLoading v-if="loading"/>
        <div v-else class="quick-response-item" v-for="(item, idx) of listTemplateFilters" v-bind:key="item._id" :style="`${idx === 0 ? 'border-top: 1px solid #D0D4E2': ''}`">
          <div class="list-quick-response-content">
            <ul>
              <li class="content-title">
                {{ item.title }}
              </li>
              <li class="content-desc">
                {{ item.content }}
              </li>
              
            </ul>
            <div class="content-desc">
                {{ getRsCategoryName(item.skillGroup) | capitalize }}
            </div>
          </div>
          <div class="list-quick-response-action">
            <v-btn flat icon class="btn-edit" @click="openDialogUpdateQuickResponse(item)">
              <img src="@/assets/icons/pencil-line.svg" alt=""/>
            </v-btn>
            <v-btn flat icon class="btn-delete" @click="deleteAgentQuickResponse(item)">
              <img src="@/assets/icons/delete.svg" alt=""/>
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </SettingItemBox>
</template>

<script>
import i18n from "@/plugins/i18n";
import AgentQuickResponseLoading from "components/custom/AgentQuickResponseLoading";
import utils from "@/services/utils";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import SettingItemBox from "components/settings/SettingItemBox";

export default {
  name: "AgentQuickResponse",
  components: {SettingItemBox, AgentQuickResponseLoading},
  props: {
    botCode: String,
  },
  data() {
    return {
      search: "",
      sortBy: "time",
      filteredSkill: -1,
      selectItems: [
        {label: `${i18n.t('time')}`, value: 'time'},
        {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
      ],
    }
  },
  mounted() {    
    if(this.botCode) {
      this.getAllAgentQuickResponseLeader(this.botCode)
    }
  },
  computed: {
    ...mapState('agentQuickResponse', ['loading', 'listResponseTemplateLeader','isLockReport']),
    ...mapState('autoAssign',['autoAssignCfg']),
    ...mapState(['user']),
    skillGroupOptions: function(){
      // let foundSupporter = this.autoAssignCfg.supporters.find(item => item.id === this.user.id);
      // let currentRsCategories = (foundSupporter && foundSupporter.auto_assign_config.request_support_categories) ? foundSupporter.auto_assign_config.request_support_categories : []
      if(this.autoAssignCfg.rs_categories){
        // let idMap = {};
        // for (let item of this.autoAssignCfg.rs_categories) {
        //     idMap[item.id] = item;
        // }

        // // Biến đổi mảng a thành dạng tương ứng với b
        // let result = [];
        // for (let id of currentRsCategories) {
        //     if (idMap[id]) {
        //         result.push(idMap[id]);
        //     }
        // }
        let result = [...this.autoAssignCfg.rs_categories]; // Clone the array to avoid mutating the original array
          result.unshift({ id: 0, name: this.capitalizeFirstLetter(this.$t("noSkill")) });
          result.unshift({id: -1, name: this.capitalizeFirstLetter(this.$t('all'))});
        // let result = this.autoAssignCfg.rs_categories.concat([{id: 0, name: this.capitalizeFirstLetter(this.$t('noSkill'))}, {id: -1, name: this.capitalizeFirstLetter(this.$t('all'))} ])
        return result
      }
      return []
    },
    listTemplateFilters: function () {
      let key = utils.removeVietnameseTones(this.search.trim().toLowerCase());
      let list = this.listResponseTemplateLeader;
      //Filter search
      if (key) {
        list = _.filter(this.listResponseTemplateLeader, (item) => {
          let _title = utils.removeVietnameseTones(item.title.toLowerCase())
          let _group = utils.removeVietnameseTones((item.group || '').toLowerCase())
          let _skillGroup = utils.removeVietnameseTones((item.skillGroup || '').toLowerCase())
          return _title.includes(key) || _group.includes(key) || _skillGroup.includes(key)
        })
      }
      if(this.filteredSkill!==""){
        list = _.filter(list, (item) => {
          return this.filteredSkill==="" || parseInt(item.skillGroup)===this.filteredSkill || this.filteredSkill < 0
        })
      }
     
      switch (this.sortBy) {
        case 'time':
          list = _.orderBy(list, ['created_time'], ['desc'])
          break;
        case 'often_used':
          list = _.orderBy(list, ['numberOfUses'], ['desc'])
          break;
        default:
          break;
      }
      return list
    }
  },
  methods: {
    ...mapActions('dialog', ['openDialogUpdateQuickResponse', 'openDialogCreateQuickResponseLeader', 'openDialogImportAgentQuickResponseLeader']),
    ...mapActions('agentQuickResponse', ['getAllAgentQuickResponseLeader', 'deleteAgentQuickResponse','exportAgentQuickResponseLeader', 'unlockReport']),
    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getRsCategoryName(id){

      if(this.autoAssignCfg.rs_categories){
        let rsCategories = this.autoAssignCfg.rs_categories.concat({ id: 0, name: this.$t("noSkill") });
        const foundItem = rsCategories.reduce((acc, item) => {
        if (item.id === parseInt(id)) {
            return item.name;
        }
        return acc;
        }, null);

        return foundItem;
        }
        else {
          return ""
        }
      }
      
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.selectItems = [
          {label: `${i18n.t('time')}`, value: 'time'},
          {label: `${i18n.t('oftenUsed')}`, value: 'often_used'},
        ]
      }
    },
    botCode() {
      if (this.botCode) {
        this.getAllAgentQuickResponseLeader(this.botCode)
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../components/style/settings/settings-quick-reply";
</style>
